import React from 'react';
import { Checkbox } from '../../comps/checkbox';
import { ls } from '../../locale';
import { numberFormatter, stringFormatter } from '../../helpers';

type HoldBookingProps = {
  holding: boolean;
  price: number;
  currencyCode: string;
  onChange: (checked: boolean) => void;
};  

export const HoldBooking = ({holding, price, currencyCode, onChange}: HoldBookingProps) => {

  const handleChange = (checked: boolean) => {
    onChange(checked);
  };

  const rHoldBooking = ls.t('CheckoutPage.HoldBooking')
  const detail = stringFormatter.formatString(rHoldBooking.Detail, `${currencyCode} ${numberFormatter.formatCurrency(price)}`)

  return (
    <div className="tw-mb-12">
      <h1>{rHoldBooking.Title}</h1>
      <div className="tw-flex tw-flex-row tw-gap-2">
        <div className="tw-flex tw-items-center tw-justify-center">
          <img src="/images/hold-booking.png" alt="Hold Booking" className="tw-w-12 tw-h-12 tw-object-cover"/>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-between">
          <div>{rHoldBooking.Desc}</div>
          <Checkbox checked={holding} onChange={handleChange}>{detail}</Checkbox>
        </div>
      </div>
    </div>
  );
}

